import * as api from '../../services/reason_code/api_reason_code';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as SagaCommon from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListReasonCodeSaga(feathersApp) {
	yield takeLatest('FETCH_LIST_REASON_CODE', callFetchListReasonCode, feathersApp);
}

function* callFetchListReasonCode(feathersApp, action) {
	const { silent, filters } = action;
	yield SagaCommon.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: 'reason_code'
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield SagaCommon.showErrorListTable(error);
	}
}


export function* saveReasonCodeSaga(feathersApp) {
	yield takeEvery("SAVE_REASON_CODE", callSaveReasonCode, feathersApp);
}
function* callSaveReasonCode(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveReasonCode, feathersApp, params);
		yield SagaCommon.doneSaveRecord(result, 'Reason code was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListReasonCode(feathersApp, { silent: true });

	} catch (e) {
		yield SagaCommon.showErrorSaveRecord(e);
	}
}

export function* deleteReasonCodeFromListSaga(feathersApp) {
	yield takeEvery('DELETE_REASON_CODE_FROM_LIST', callDeleteReasonCodeFromList, feathersApp);
}

function* callDeleteReasonCodeFromList(feathersApp, action) {
	yield deleteReasonCode(feathersApp, action);
	yield delay(2000);
	yield callFetchListReasonCode(feathersApp, { silent: true });
}

function* deleteReasonCode(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteReasonCode, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.REASON_CODE } });
			yield callFetchListReasonCode(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteReasonCodeSaga(feathersApp) {
	yield takeEvery('DELETE_REASON_CODE', callDeleteReasonCode, feathersApp);
}

function* callDeleteReasonCode(feathersApp, action) {
	const result = yield deleteReasonCode(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/reason_code');
	}
}

export function* fetchReasonCodeForEditSaga(feathersApp) {
	yield takeEvery('FETCH_REASON_CODE_BY_ID', callFetchReasonCodeForEdit, feathersApp);
}

function* callFetchReasonCodeForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.REASON_CODE;
	try {
		if (id) {
			yield put({ type: 'FETCH_DATA_BY_ID_INPROGRESS', payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchReasonCodeById, feathersApp, fetchParams);
			yield SagaCommon.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
